import {
    type LogoutResponseType
} from "./type";
import {
    request
} from "../request";

const Logout = async (): Promise<LogoutResponseType> => {
    return await request<LogoutResponseType>("/auth/logout", {
        method: "GET"
    });
};

export default Logout;
